import { useEffect, useState } from 'react';
import Main from '../../../component/Main.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import { useIs17Inch } from '../../../hooks/useBreakPoint.js';

const BdJrNaeyeokListA = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchGubun: '',
        searchGubunS: '',
        searchDateCls: '01',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        validationCheckList: ['searchLoca']
    });

    const searchParamsAdditional = {
        searchType: 'List3',
        searchCheck1: 'New'
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['의료기관명', '기관코드', '지역', '종별', '의무기록번호', '중증도분류선별번호', '성명', '나이/성별', '주소지', '보험유형', '내원일자', '내원시간', '발병일자(*)', '발병시간(*)', '질병여부(*)', '의도성여부(*)', '손상기전(*)', '교통사고손상당사자', '안전벨트', '아동용좌석', '전면에어백', '측면에어백', '헬멧', '무릎및관절보호대', '기타(구명조끼 등)', '전혀착용안함', '비해당', '미상', '주진료과(*)', '내원경로(*)', '전원보낸의료기관종류', '전원보낸의료기관코드', '전원보낼의료기관종류', '전원보낼의료기관코드', '내원수단(*)', '구급활동일지', '주증상(*)', '응급증상 해당여부', '기타증상', '진료결과(*)', '진료결과기타사유', '환자내원시반응(*)', '수축기혈압', '이완기혈압', '분당맥박수', '분당호흡수', '체온', '내원 시 산소포화도', '중증도분류과정(최초)', '중증도분류결과(최초)', '중증도분류일자(최초)', '중증도분류시간(최초)', '중증도 분류자의 직종', '최초 분류자의 면허 또는 자격번호', '중증도분류과정(변경)', '중증도분류결과(변경)', '퇴실시 최종진료구역', '주된진료를 받은 응급의료센터', '전문의 진료여부', '전문의 진료일자', '전문의 진료시간', '격리구역 병상번호', '입원경로', '진료의사 면허번호', '퇴실일자(*)', '퇴실시간(*)', '퇴실진단(*)', '퇴실진단(영문명)', '입원일자', '입원시간', '입원후결과(퇴원형태)', '퇴원일자', '퇴원시간', '퇴원진단', '퇴원진단(영문명)', '전송일자', '상태'];
    const dataColumn = ['EMOGDESC', 'PTMIEMCD', 'EMOGLOCA', 'EMOGGRDC2', 'PTMIIDNO', 'PTMIKTID', 'PTMINAME', 'PTMISEXX', 'PTMIZIPC', 'PTMIIUKD', 'PTMIINDT', 'PTMIINTM', 'PTMIAKDT', 'PTMIAKTM', 'PTMIDGKD', 'PTMIARCF', 'PTMIARCS', 'PTMITAIP', 'PTMITSBT', 'PTMITSCS', 'PTMITSFA', 'PTMITSSA', 'PTMITSHM', 'PTMITSPT', 'PTMIETCT', 'PTMITSNO', 'PTMITSUR', 'PTMITSUK', 'PTMIDEPT', 'PTMIINRT', 'PTMIINTP', 'PTMIINCD', 'PTMIDCTP', 'PTMIDCCD', 'PTMIINMN', 'PTMIREID', 'SYPTCHCO', 'PTMIEMSY', 'PTMIETSY', 'PTMIEMRT', 'PTMIETTX', 'PTMIRESP', 'PTMIHIBP', 'PTMILOBP', 'PTMIPULS', 'PTMIBRTH', 'PTMIBDHT', 'PTMIVOXS', 'PTMIKPR1', 'PTMIKTS1', 'PTMIKTDT', 'PTMIKTTM', 'PTMIKJOB', 'PTMIKIDN', 'PTMIKPR2', 'PTMIKTS2', 'PTMIAREA', 'PTMIMDCD', 'PTMISDCD', 'SDMDSDDT', 'SDMDSDTM', 'PTMIBENO', 'PTMIHSRT', 'PTMIDRLC', 'PTMIOTDT', 'PTMIOTTM', 'DGOTDESC', 'DGOTNAME', 'PTMIHSDT', 'PTMIHSTM', 'PTMIDCRT', 'PTMIDCDT', 'PTMIDCTM', 'DGDCDESC', 'DGDCNAME', 'PTMIWKDT', 'PTMISTAT'];
    const apiCall = '/ptmiapi/jinryo/bdjrnaeyeokdetaillistAsearch.do';
    const apiCntCall = '/ptmiapi/jinryo/bdjrnaeyeokdetaillistAsearchCnt.do';
    const excelFileName = '환자내역조회';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    useEffect(() => {
        setSearchParams(prev => ({
            ...prev,
            searchGubunS: '*'
        }));
    }, [searchParams.searchGubun]);

    const is17Inch = useIs17Inch();

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="6%" />
                        <col width="21%" />
                        <col width="5%" />
                        <col width="23%" />
                        <col width="6%" />
                        <col width="17%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>
                                <select
                                    id="searchDateCls"
                                    name="searchDateCls"
                                    value={searchParams.searchDateCls}
                                    onChange={handleInputChange}
                                >
                                    <option value="01">내원일시</option>
                                    <option value="02">전송일시</option>
                                </select>
                            </th>
                            <td>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                            <th>구분</th>
                            <td>
                                <label style={{ marginRight: '13px' }}>
                                    <input
                                        type="radio"
                                        name="searchGubun"
                                        value=""
                                        checked={searchParams.searchGubun === ''}
                                        onChange={handleInputChange}
                                    />
                                    전체
                                </label>
                                <label style={{ marginRight: '13px' }}>
                                    <input
                                        type="radio"
                                        name="searchGubun"
                                        value="C"
                                        checked={searchParams.searchGubun === 'C'}
                                        onChange={handleInputChange}
                                    />
                                    대상
                                </label>
                                <label style={{ marginRight: '13px' }}>
                                    <input
                                        type="radio"
                                        name="searchGubun"
                                        value="F"
                                        checked={searchParams.searchGubun === 'F'}
                                        onChange={handleInputChange}
                                    />
                                    완료
                                </label>
                                <select
                                    id="searchGubunS"
                                    name="searchGubunS"
                                    value={searchParams.searchGubunS}
                                    onChange={handleInputChange}
                                    className={is17Inch ? 'w-20' : 'w-28'}
                                >
                                    <option value="*">상태 전체</option>
                                    {searchParams.searchGubun !== 'F' && <option value="H">생성</option>}
                                    {searchParams.searchGubun !== 'C' &&
                                        <>
                                            <option value="G">퇴실완료</option>
                                            <option value="B">퇴실재검토필요</option>
                                            <option value="Y">퇴실재검토완료</option>
                                            <option value="S">퇴원완료</option>
                                            <option value="N">퇴원재검토필요</option>
                                            <option value="Z">퇴원재검토완료</option>
                                        </>
                                    }
                                    {searchParams.searchGubun === '' &&
                                        <>
                                            <option value="D">삭제</option>
                                            <option value="E">오류</option>
                                            <option value="C">접수취소</option>
                                        </>
                                    }
                                </select>
                            </td>
                            <th>등록번호</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchIdno"
                                    name="searchIdno"
                                    value={searchParams.searchIdno}
                                    onChange={handleInputChange}
                                    className='w-full'
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
        </Main>
    )
}

export default BdJrNaeyeokListA;